var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("img", {
    class: _vm.rootClasses,
    attrs: { src: _vm.src, srcset: _vm.srcSet, alt: _vm.alt }
  })
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2d288fa0", { render: render, staticRenderFns: staticRenderFns })
  }
}